import styled, { css } from 'styled-components'

const variants: Record<'default' | 'alternative', (props: any) => string> = {
  default: props => `
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: ${props.theme.spacing.default} ${props.theme.spacing.default};
    border-radius: ${props.theme.radius.normal};
    background-color: ${props.theme.colors.black[100]};

    span {
      font-size: ${props.theme.font.small};
      font-weight: ${props.theme.fontWeight.medium};
      margin-left: ${props.theme.spacing.small};
    }
    img {
      height: 1.5rem;
      margin-right: ${props.theme.spacing.small}
    }
  `,
  alternative: props => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${props.theme.spacing.default} ${props.theme.spacing.medium};
    border-radius: ${props.theme.radius.normal};
    background-color: #F5F5FF;
    width: 100%;

    div: first-of-type {
      min-width: 2.5rem;
      img {
        height: 2rem;
      }
    }

    div: last-of-type {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    span {
      margin-left: ${props.theme.spacing.medium};
    }
    
  `,
}

export const Label = styled.section<{ variant?: 'default' | 'alternative' }>`
  ${props =>
    css`
      ${variants[props?.variant || 'default'](props)}
    `}
`
